import { useMutation } from "react-query";
import { deleteWipMeasurements } from "components/measuring/lib/measuring-data";

export const useDeleteMeasurementWipKeys = () => {
    return useMutation(async ({ keys, selectedUpcs }) => {
        const multiMeasuringWipWithKeys = selectedUpcs.map((upc, index) => ({
            measuringWipKey: upc.measuringWipKey,
            measurementKey: keys[index],
        }));

        const savePromises = multiMeasuringWipWithKeys.map((value) => {
            return deleteWipMeasurements(value.measuringWipKey, value.measurementKey);
        });

        return Promise.all(savePromises);
    });
};
